<template>
  <div>
    <Table :columns="columns1" :data="list"></Table>
  </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    export default {
        data(){
            return {
                compet_id:0,
                list:[],
                columns1: [
                        {
                            type: 'index',
                            title:"序号",
                            key:"number",
                        },
                        {
                            title:"得分",
                            key:"score",
                        },
                        {
                            title:"时间",
                            key:"mark_time"
                        },
                ]
            }
        },
        computed:{

        },

        methods:{
            ...mapActions({
                getTeamSubmitScore:'team/getTeamSubmitScore',
            }),
            getList(){
                let _this = this;
                _this.getTeamSubmitScore({
                    data:{
                        compet_id:_this.compet_id,
                    },
                    callback:res=>{
                        _this.list = res;
                    },
                    error:msg=>{
                        console.log(msg);
                        _this.$Message.error(msg);
                    }
                })
            }
        },
        mounted(){
            let _this = this;
            _this.compet_id = this.$route.params.id;
            if(_this.compet_id > 0){
                this.getList();
            }
        }
    }
</script>